import { isSearchMode, SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
const qModeBySearchMode = {
    [SearchMode.SEARCH]: 'search',
    [SearchMode.RESEARCH]: 'research',
    [SearchMode.AGENTIC_RESEARCH]: 'model-council',
    [SearchMode.STUDY]: 'learn-files-and-apps',
    [SearchMode.BROWSER_AGENT]: 'control-browser',
    [SearchMode.ASI]: 'computer',
};
export function getQModeForSearchMode(searchMode) {
    return qModeBySearchMode[searchMode];
}
export function getSearchModeForQMode(modeValue) {
    const entry = Object.entries(qModeBySearchMode).find(([, value]) => value === modeValue.toLowerCase());
    if (!entry) {
        return undefined;
    }
    const [mode] = entry;
    if (!isSearchMode(mode)) {
        return undefined;
    }
    return mode;
}
//# sourceMappingURL=searchModeQMode.js.map